import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    Box,
    Typography,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainerEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import MKButton from "components/MKButton";
import { useNavigate } from 'react-router-dom';
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import '../../../styles.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
    return (
        <>
            {loading && (
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        filter: 'blur(5px)',
                        pointerEvents: 'none',
                    }}
                    open={loading}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            zIndex: "1",
                            width: "100%",
                            minHeight: "100vh",
                            // display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    >
                        {children}
                    </Box>
                </Backdrop>
            )}
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: (theme) => theme.zIndex.drawer + 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!loading && children}
        </>
    );
};

const TrainerRecruitSeeMore = () => {
    const [userId, setUserId] = useState("");
    const [trainerRecruitDetails, setTrainerRecruitDetails] = useState([]);
    const [maxRemainderCount, setMaxRemainderCount] = useState(false);
    const [submitRemainderCompleted, setSubmitRemainderCompleted] = useState(false);
    const [recruitSubmitCompleted, setRecruitSubmitCompleted] = useState(false);
    const [responseFromDB, setResponseFromDB] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        let id = localStorage.getItem("userId");
        console.log(id);
        let display = "card";
        fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-trainer-recruit/${id}/${display}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setTrainerRecruitDetails(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [userId]);
    console.log("trainerRecruitDetails", trainerRecruitDetails);

    const [trainerDetails, setTrainerDetails] = useState([]);
	useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerDetails", trainerDetails);

    const onRecruitRemainderClick = (training) => {
        setLoading(true);
        setMaxRemainderCount(false);
        console.log("recruitRemainder", training.trainerRecruitID);
        const data = {
            id: training.trainerRecruitID,
            premiumStatus: trainerDetails.premiumStatus,
        };
        console.log(JSON.stringify(data));
        fetch(`${process.env.REACT_APP_API_URL}/api/redir-company-status-intodb-reminder/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    setSubmitRemainderCompleted(false);
                    throw new Error("Profile is not created. Something went wrong");
                }
            })
            .then((data) => {
                console.log("Response from backend:", data.message);
                if (data.message === "Remainder reached maximum for the day") {
                    setResponseFromDB(data.message);
                    setMaxRemainderCount(true);
                } else if (data.message === "Trainer's Accept/ Decline status successfully updated in DB" || data.message === "count update and date updated, mail sent") {
                    setResponseFromDB(data.message);
                    setSubmitRemainderCompleted(true);
                    setLoading(false);
                } else {
                    setResponseFromDB(data.message);
                    setSubmitRemainderCompleted(false);
                }
            })
            .catch((error) => {
                console.log("Error:", error.message);
            });
    };
    console.log("responseFromDB", responseFromDB);

    const onRecruitAgreeClick = (company) => {
        setLoading(true);
        console.log("2222222222", company);
        const data = {
            trainerAcceptStatus: "Accept",
            trainingCompanyID: company.user_id,
            trainerID: company.trainerID,
        };
        console.log(JSON.stringify(data));
        fetch(`${process.env.REACT_APP_API_URL}/api/redir-trainerdashboard-status-intodb/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),

        })
            .then((response) => {
                if (response.ok) {
                    console.log("aaaaaaaaaaa");
                    setRecruitSubmitCompleted(true);
                    setLoading(false);
                } else {
                    setRecruitSubmitCompleted(false);
                    throw new Error("Response not posted. Something went wrong");
                }
            })
            .then((data) => {
                console.log("fffffffffffffffff");
            })
            .catch((error) => {
                console.log("oooooooooooooooo", error.message);
            });
    };

    const onRecruitedTrainingCompanyMoreDetails = (training) => {
        console.log("training", training.trainerRecruitID);
        navigate(`/app/recruitedtrainingcompanymoredetails/${training.trainerRecruitID}/`);
    };

    const DialogProfileRecruitAcceptClose = () => {
        setRecruitSubmitCompleted(false);
        window.location.href = "/app/trainerdashboard";
    };

    const DialogProfileClose = () => {
        setSubmitRemainderCompleted(false);
        window.location.href = "/app/trainerdashboard";
    };

    function getStatus(trainingCompanyRecruitStatus, trainerAcceptStatus, trainingCompanyAgreeStatus) {
        if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === null && trainingCompanyAgreeStatus === null) {
            return "Awaiting for Your response";
        } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === null) {
            return "Awaiting for Training Partner's response";
        } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Decline" && trainingCompanyAgreeStatus === null) {
            return "You have Declined the Training Partner's request";
        } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Accept") {
            return "Mutually agreed for the training";
        } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Decline") {
            return "Trainer has been rejected";
        } else {
            return "Status not available";
        }
    }

    const renderTrainerCards = (trainings) => {
        return trainings.map((training, index) => (
            <Grid item xs={6} key={training.id} >
                <div className="gridItemSeeMore">
                    <div className="gridContent">
                        <div className="trainingInfo">
                            <Typography variant="subtitle1" className="trainingName"><strong>{training.companyName}</strong></Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.displaySkills}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong>Clients:&nbsp;</strong>{training.clients}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong>TimeZone:&nbsp;</strong>{training.supportedClientTimezone}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <strong>Status:&nbsp;{getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus)}</strong>
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                            <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitedTrainingCompanyMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                        </div>
                        {getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus) === "Awaiting for Training Partner's response" && (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                    <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitRemainderClick(training)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>
                                </div>
                            </>
                        )}
                        {getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus) === "Awaiting for Your response" && (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                    <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitAgreeClick(training)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Grid>
        ));
    };


    return (
        <>
            <LoadingOverlay loading={loading}>
                <IdleTimeOutHandler />
                <DefaultNavbar
                    routes={editRoutes}
                    sticky
                />
                <Card
                    sx={{
                        minHeight: '101vh',
                        height: 'auto',
                        p: 2,
                        mx: { xs: 2, lg: 3 },
                        mt: -8,
                        mb: 4,
                        // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                        backdropFilter: "saturate(200%) blur(30px)",
                        boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    }}
                >
                    <Dialog
                        open={recruitSubmitCompleted}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Notification !
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Your response submitted to the training partner.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                            <MKButton onClick={() => { setRecruitSubmitCompleted(false); DialogProfileRecruitAcceptClose(); }} variant="contained" color="info" size="small" autoFocus>
                                OK
                            </MKButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={submitRemainderCompleted}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Great news!
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Reminder sent successfully! Your gentle nudge has been delivered.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                            <MKButton onClick={() => { setSubmitRemainderCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                                OK
                            </MKButton>
                        </DialogActions>
                    </Dialog>
                    <div>
                        {maxRemainderCount ? (
                            <MKAlert color="error" dismissible >
                                You've reached the daily remainder limit !
                            </MKAlert>
                        ) : (
                            ""
                        )}
                    </div>
                    <Container>
                        <Grid container>
                            <Grid item xs={12} style={{ marginTop: "150px" }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                                        <Grid item xs={12} style={{ display: 'flex' }}>
                                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                                                <span style={{ color: 'black' }}>Recurited</span>{' '}
                                                <span style={{ color: '#2e1114' }}>Training Partner</span>
                                            </MKTypography>
                                        </Grid>
                                    </Grid>

                                    {trainerRecruitDetails.length === 0 ? (
                                        <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>You have not been recruited by any training partner at the moment.</span>
                                    ) : (
                                        ""
                                    )}

                                    {trainerRecruitDetails.length === 0 ? (
                                        ""
                                    ) : (
                                        <Grid container spacing={2}>
                                            {renderTrainerCards(trainerRecruitDetails)}
                                        </Grid>
                                    )}

                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </Card>
            </LoadingOverlay>
        </>
    );
};

export default TrainerRecruitSeeMore;